import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M51.2365 232.517H110.438C111.593 232.517 112.17 233.095 112.17 234.25V242.047C112.17 254.754 120.545 262.84 131.808 262.84C143.359 262.84 151.445 254.754 151.445 242.047V234.25C151.445 233.095 152.023 232.517 153.178 232.517H154.333C165.596 232.517 173.104 225.298 173.104 214.901C173.104 204.794 165.596 197.574 154.333 197.574H153.178C152.023 197.574 151.445 196.997 151.445 195.841V169.851C151.445 157.144 143.359 149.058 131.808 149.058C120.545 149.058 112.17 157.144 112.17 169.851V195.841C112.17 196.997 111.593 197.574 110.438 197.574H74.9169V196.997L122.567 92.1674C123.722 89.5683 124.588 85.8141 124.588 82.6374C124.588 70.7972 116.213 63 105.239 63C96.5759 63 90.2226 67.9094 86.7572 75.7066L35.6421 190.066C31.0215 200.462 29 204.794 29 212.013C29 224.431 37.3748 232.517 51.2365 232.517Z",
      fill: "#E5E5E5"
    }, null, -1)
  ])))
}
export default { render: render }